module.exports = __webpack_public_path__ + "static/media/waze.be82302a.png";